export const isIframeEmpty = (iframe: HTMLIFrameElement | null): boolean => {
    if (!iframe) return false;

    const iframeWindow = iframe.contentWindow;
    if (!iframeWindow) return false;

    if (iframe.offsetHeight === 0 && iframe.clientHeight === 0) {
        return true;
    }

    try {
        const iframeLocation = iframeWindow.location.href;
        if (iframeLocation === 'about:blank' || iframeLocation === 'about:srcdoc') {
            return true;
        }
    } catch (e) {
    }

    try {
        const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
        if (!iframeDoc) {
            if (iframe.offsetHeight < 50 && iframe.clientHeight < 50) {
                return true;
            }
            return false;
        }

        try {
            const docURL = iframeDoc.URL || iframeDoc.location?.href;
            if (docURL === 'about:blank' || docURL === 'about:srcdoc') {
                return true;
            }
        } catch (e) {
        }

        const html = iframeDoc.documentElement;
        const body = iframeDoc.body;
        const head = iframeDoc.head;

        if (!body || !html) {
            return true;
        }

        const htmlInnerHTML = html.innerHTML.trim();
        const bodyInnerHTML = body.innerHTML.trim();
        const bodyTextContent = body.textContent?.trim() || '';
        const bodyChildrenCount = body.children.length;
        const headChildrenCount = head ? head.children.length : 0;

        const normalize = (str: string) => str.replace(/\s+/g, ' ').trim();
        const normalizedHtmlInner = normalize(htmlInnerHTML);
        const normalizedBody = normalize(bodyInnerHTML);

        const isEmptyStructure =
            htmlInnerHTML === '' ||
            normalizedHtmlInner === '<head></head><body></body>' ||
            normalizedHtmlInner === '<head></head>' ||
            normalizedHtmlInner === '<body></body>' ||
            (normalizedHtmlInner.length < 30 && bodyChildrenCount === 0 && headChildrenCount === 0);

        if (isEmptyStructure) {
            return true;
        }

        if (bodyInnerHTML === '' ||
            normalizedBody === '' ||
            bodyChildrenCount === 0 && bodyTextContent.length === 0) {
            return true;
        }

        if (bodyChildrenCount === 0 && headChildrenCount === 0 && bodyTextContent.length === 0 &&
            (normalizedHtmlInner === '<head></head><body></body>' || normalizedHtmlInner.length < 50)) {
            return true;
        }

    } catch (docError) {
        if (iframe.offsetHeight < 50 && iframe.clientHeight < 50) {
            return true;
        }
    }

    return false;
};

